<script setup></script>

<template>
  <ul class="c-listbox__group" role="group">
    <li class="c-listbox__category" role="presentation">
      <slot name="category" />
    </li>
    <slot name="options" />
  </ul>
</template>

<style lang="scss">
@import '@/ui/styles/functions/functions';
@import '@/ui/styles/settings/colors';
@import '@/ui/styles/settings/fonts';
@import '@/ui/styles/settings/units';

.c-listbox__group {
  margin: 0 0 $spacing-small;
  padding: 0;
  list-style: none;
}

.c-listbox__category {
  margin: 0 0 $spacing-small;
  padding: $spacing-small rem(20px);
  background-color: $ssen-light-grey;
  color: $color-neutral-dark;
  font-size: rem(18px);
  font-weight: $font-weight-semi-bold;
  line-height: (24 / 18);
}
</style>
